import React, { useEffect, useState, useMemo } from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { useDispatch, useSelector } from "react-redux";
import { Form, Input } from "antd";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";

import {
  FieldContainer,
  CustomSelect,
  Option,
} from "../../components/CustomFields";
import SearchIcon from "../../assets/icons/search.svg";
import GenCodePasswordTable from "../../components/GenCodePassword/Table";
import {
  fetchStudents,
  generateResetPasswordCode,
} from "../../stores/genCodePassword";

import { responsive } from "../../utils/style";

export default () => {
  const dispatch = useDispatch();

  const [data, setData] = useState([]);
  const [showSearch, setShowSearch] = useState(false);

  const { students } = useSelector((state) => state.genCodePassword);
  const { roomUnit = 0 } = useSelector((s) => s.auth.userInfo);

  const [form] = Form.useForm();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();

  const classNo = searchParams.get("classNo");
  const roomNo = searchParams.get("roomNo");

  useMemo(() => {
    setData(students);
  }, [students]);

  useEffect(() => {
    dispatch(fetchStudents({ classNo, roomNo }));
    if (classNo && roomNo) setShowSearch(true);
  }, [classNo, roomNo]);

  const handleChange = () => {
    const values = form.getFieldsValue(true);
    const filterParams = Object.entries(values).reduce(
      (a, [k, v]) => (v ? ((a[k] = v), a) : a),
      {}
    );
    const params = new URLSearchParams(filterParams);
    navigate({ pathname: location.pathname, search: params.toString() });
  };

  const handleSearch = (e) => {
    if (e.target.value) {
      const regex = new RegExp(e.target.value);
      const filterData = data.filter((d) => regex.test(d.name));
      setData(filterData);
    } else {
      setData(students);
    }
  };

  const handleGenCode = (id) => {
    dispatch(generateResetPasswordCode({ id, role: "student" }));
  };

  return (
    <Container>
      <Background>
        <Content>
          <Topic>โค้ดสำหรับการเปลี่ยนรหัสผ่านสำหรับสามเณร</Topic>
          <SubTopic>ข้อมูลโค้ดสำหรับการเปลี่ยนรหัสผ่าน</SubTopic>
          <Form
            form={form}
            name="nutritionViews"
            layout="vertical"
            autoComplete="off"
            initialValues={{
              classNo,
              roomNo,
            }}
          >
            <GroupField>
              <FieldContainer name="classNo" label="ชั้น" marginBottom={0}>
                <CustomSelect
                  placeholder="โปรดระบุ"
                  allowClear
                  width="100%"
                  widthRs="100%"
                  onChange={handleChange}
                >
                  {[...Array(6).keys()].map((i) => (
                    <Option key={i} value={i + 1}>
                      ม.{i + 1}
                    </Option>
                  ))}
                </CustomSelect>
              </FieldContainer>
              <FieldContainer name="roomNo" label="ห้อง" marginBottom={0}>
                <CustomSelect
                  placeholder="โปรดระบุ"
                  allowClear
                  width="100%"
                  widthRs="100%"
                  onChange={handleChange}
                >
                  {[...Array(roomUnit).keys()].map((i) => (
                    <Option key={i} value={i + 1}>
                      {i + 1}
                    </Option>
                  ))}
                </CustomSelect>
              </FieldContainer>
            </GroupField>
            {showSearch && (
              <FieldContainer name="name" marginBottom={0}>
                <Input
                  placeholder="ระบุชื่อเพื่อค้นหา"
                  type="text"
                  onChange={handleSearch}
                />
                <SearchImage src={SearchIcon} />
              </FieldContainer>
            )}
          </Form>
        </Content>
        <GenCodePasswordTable
          data={data}
          role="student"
          handleGenCode={handleGenCode}
        />
      </Background>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  font-family: Noto Sans Thai, Noto Sans;
  background-color: #fffbeb;

  ${responsive.mobile(css`
    input {
      max-width: none;
    }
  `)}
`;
const Background = styled.div`
  width: 100%;
  min-height: 100vh;
  max-width: 1144px;
  background-color: white;
  padding: 40px 187px;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${responsive.tablet(css`
    padding: 40px 24px;
    max-width: unset;
  `)}

  ${responsive.mobile(css`
    padding: 24px;
  `)}
`;
const Content = styled.div`
  max-width: 440px;
  width: 100%;

  form {
    .ant-form-item {
      display: grid;
    }

    input {
      border-radius: 4px;
      height: 52px;
      font-size: 18px;
      margin-bottom: 24px;

      ${responsive.mobile(css`
        margin-bottom: 16px;
      `)}
    }
  }
`;
const Topic = styled.h5`
  font-style: normal;
  font-weight: bold;
  font-size: 23px;
  line-height: 28px;
  letter-spacing: -0.02em;
  color: #058459;
  text-align: center;
  margin-bottom: 46px;
`;
const SubTopic = styled.p`
  font-weight: 500;
  font-size: 21px;
  line-height: 23px;
  letter-spacing: -0.02em;
  color: #4b5768;
`;
const Image = styled.img``;
const SearchImage = styled(Image)`
  position: absolute;
  right: 10px;
  top: 15px;
`;
const GroupField = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
`;
